(function () {
  'use strict';

  var SELECTOR = '[data-amazon-buy]';

  function getChannel() {
    try {
      if (window.TrafficSource && typeof window.TrafficSource.getChannel === 'function') {
        return window.TrafficSource.getChannel();
      }
    } catch (e) {
      /* fall through */
    }
    return 'direct';
  }

  function parseLinks(el) {
    var raw = el.getAttribute('data-amazon-links');
    if (!raw) return null;
    try {
      var obj = JSON.parse(raw);
      if (obj && typeof obj === 'object' && typeof obj.default === 'string' && obj.default) {
        return obj;
      }
      return null; // malformed or missing required `default`.
    } catch (e) {
      return null;
    }
  }

  function resolveOne(el) {
    var links = parseLinks(el);

    // Malformed / empty metafield: leave the server-rendered href untouched.
    // (If the snippet found nothing usable it would not have rendered the
    // element at all — so a present element always has a valid default href.)
    if (!links) return;

    var channel = getChannel();
    var url = links[channel] || links.default;

    el.setAttribute('href', url);
    el.setAttribute('data-amazon-resolved-url', url);
    el.setAttribute('data-amazon-resolved-channel', links[channel] ? channel : 'default');

    // Enforce safe external-link attributes regardless of how it was rendered.
    el.setAttribute('target', '_blank');
    el.setAttribute('rel', 'noopener noreferrer');
  }

  function resolveAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      try {
        resolveOne(buttons[i]);
      } catch (e) {
        /* one bad button must not break the others */
      }
    }
  }

  function init() {
    resolveAll(document);

    // Dawn re-renders product sections (quick-add, variant change) which can
    // swap in fresh buttons. Re-resolve when new [data-amazon-buy] nodes appear.
    if ('MutationObserver' in window) {
      try {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType !== 1) continue;
              if (node.matches && node.matches(SELECTOR)) {
                resolveOne(node);
              } else if (node.querySelector && node.querySelector(SELECTOR)) {
                resolveAll(node);
              }
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      } catch (e) {
        /* observation unavailable — initial resolve already ran */
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
